
const digest = 'b19957c6430d05ed05488ecce0f580ceedb5fc942edc099aa5d874f5700b556f';
const classes = {"wrapper":"_wrapper_fq30v_1","uploadButton":"_uploadButton_fq30v_1","placeholder":"_placeholder_fq30v_17","input":"_input_fq30v_24","preview":"_preview_fq30v_27","image":"_image_fq30v_33"};
const css = `._wrapper_fq30v_1 ._uploadButton_fq30v_1 {
  font-size: 16px;
  font-weight: 600;
  padding: 25px 20px;
  width: 100%;
  text-align: left;
  position: relative;
  background: #eaf2ff;
  background: linear-gradient(180deg, #eaf2ff 0, #cad9f3 100%);
  color: #3c3f9c;
  border-radius: 15px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
._wrapper_fq30v_1 ._placeholder_fq30v_17 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}
._wrapper_fq30v_1 ._input_fq30v_24 {
  display: none;
}
._wrapper_fq30v_1 ._preview_fq30v_27 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
}
._wrapper_fq30v_1 ._preview_fq30v_27 ._image_fq30v_33 {
  height: 175px;
  width: 100%;
  border: 2px solid #dbd6f0;
  object-fit: cover;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  